<template>
  <b-container fluid>
    <b-row>
      <b-col class="text-center">
        <h1 v-if="!$route.params.trackid" class="text-center">
          Upload Questions by {{ uploadmethod }}
          {{ uploadmethod == "File" ? "Upload" : "Input" }}
        </h1>
        <b-button-group
          v-if="!$route.params.trackid"
          size="lg"
          class="text-center mb-3"
        >
          <b-button
            variant="primary"
            @click="uploadmethod = 'Text'"
            :class="
              uploadmethod == 'Text' ? 'active-method' : 'inactive-method'
            "
            >Upload by Text</b-button
          >
          <b-button
            variant="primary"
            @click="uploadmethod = 'File'"
            class="up-btn"
            :class="
              uploadmethod == 'File' ? 'active-method' : 'inactive-method'
            "
            >Upload by File</b-button
          >
        </b-button-group>

        <h2 v-if="$route.params.trackid">Edit Question</h2>
      </b-col>
    </b-row>
      <b-overlay :show="fetching">
        <template #overlay>
          <div class="text-center">
            <b-icon-circle
              font-scale="3"
              animation="throb"
            ></b-icon-circle>
            <p>Fetching Question..</p>
          </div>
        </template>

        <b-row>
          <b-modal
            id="modal-leave"
            centered
            title="Confirm Exit"
            ok
            ok-variant="danger"
            cancel-variant="success"
            @ok="leaveRoute"
            @cancel="stayRoute"
          >
            <template v-slot:modal-ok> Leave </template>
            <p>Are You sure you want to leave. You may loose unsaved changes.</p>
          </b-modal>

          <b-col v-if="uploadmethod == 'Text'" class="m-0 p-0">
            <form @submit.prevent="setQuestion">
              <b-overlay :show="sent" rounded="sm">
                <template #overlay>
                  <div class="text-center">
                    <b-icon-circle
                      font-scale="3"
                      animation="throb"
                    ></b-icon-circle>
                    <p>Uploading Question..</p>
                  </div>
                </template>
                <b-card bg-variant="light" class="m-0 p-0">
                  <b-form-group class="mb-0">
                    <div v-if="uploaded" class="alert alert-success p-3">
                      Question Uploaded
                    </div>
                    <b-form-group label="Select category" label-for="category">
                      <b-form-select
                        id="category"
                        :options="categoryarray"
                        v-model="question.category"
                        @change="categoryChanged"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select category--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      v-if="sameName != 'Yes'"
                      label="Institution/University"
                      label-for="selectinstitution"
                    >
                      <b-form-select
                        id="selectinstitution"
                        class="form-inp"
                        :options="institutionsarray"
                        v-model="question.institution_id"
                        @change="institutionChanged"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Testgroup--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      class="nested-form-group"
                      v-if="structure == 'Section' && question.institution != null"
                      label="Select Level"
                      label-for="institution"
                    >
                      <b-form-select
                        v-model="question.level"
                        @change="chgCourses"
                        :options="levelarray"
                      >
                        <b-form-select-option v-if="plan != 'Premium'" value="null"
                          >--Select Level--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      class="nested-form-group"
                      v-if="
                        structure == 'Section' &&
                          question.institution != null &&
                          question.level != null
                      "
                      label="Select Course"
                      label-for="institution"
                    >
                      <b-form-select
                        v-model="question.course"
                        @change="chgSection"
                        :options="coursesarray"
                      >
                        <b-form-select-option value="null"
                          >--Select Course--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      class="nested-form-group"
                      v-if="
                        structure == 'Section' &&
                          question.institution != null &&
                          question.level != null &&
                          question.course != null
                      "
                      label="Select Section"
                      label-for="institution"
                    >
                      <b-form-select
                        v-model="question.section"
                        :options="sectionarray"
                      >
                        <b-form-select-option value="null"
                          >--Select Section--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      v-if="structure == 'Subject'"
                      label="Select Subject"
                      label-for="selectsubject"
                    >
                      <b-form-select
                        id="selectsbuject"
                        class="form-inp"
                        :options="subjectsarray"
                        v-model="question.subject"
                        label="Select Subject"
                        required
                      >
                        <b-form-select-option value="null"
                          >--Select Subject--</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      v-if="question.institution != null"
                      label="Any Image Attachment to Question?"
                    >
                      <b-form-radio
                        v-model="question.attachment"
                        name="attach"
                        value="Yes"
                      >
                        Yes
                      </b-form-radio>
                      <b-form-radio
                        v-model="question.attachment"
                        name="attach"
                        value="No"
                      >
                        No
                      </b-form-radio>
                    </b-form-group>

                    <b-overlay :show="uploadingqimage">
                      <template #overlay>
                        <div class="text-center">
                          <b-icon-file-image
                            font-scale="3"
                            animation="throb"
                          ></b-icon-file-image>
                          <p>Uploading Image...</p>
                        </div>
                      </template>
                      <b-form-group>
                        <b-form-file
                          v-model="question.attachmentlink"
                          v-if="question.attachment == 'Yes'"
                          ref="file"
                          placeholder="Choose a file or drop it here"
                          drop-placeholder="Drop File here..."
                          @input="handleImage"
                        ></b-form-file>
                      </b-form-group>
                      <img
                        :src="attachmentfiles"
                        v-if="question.attachment == 'Yes'"
                        class="image-attachment"
                      />
                    </b-overlay>

                    <b-form-group class="mt-2" label="Is there a Passage to be read?">
                      <b-form-radio
                        v-model="question.isPassage"
                        name="ispassage"
                        :value="true"
                      >
                        Yes
                      </b-form-radio>
                      <b-form-radio
                        v-model="question.isPassage"
                        name="ispassage"
                        :value="false"
                      >
                        No
                      </b-form-radio>
                    </b-form-group>

                    <b-form-group
                      label="Passage to read(if any)"
                      label-for="passage"
                      v-if="question.isPassage == 'Yes' || question.isPassage"
                    >
                      <vue2-tinymce-editor
                        v-model="question.passage"
                      ></vue2-tinymce-editor>
                    </b-form-group>

                    <b-form-group
                      label="Select Question Structure"
                      label-for="correct"
                    >
                      <b-form-select
                        id="correct"
                        :options="structureoptions"
                        v-model="question.structure"
                        required
                      />
                    </b-form-group>

                    <b-form-group
                      v-if="question.category != null"
                      label="Any Inline Image Attachement to Question or any of the Options?"
                    >
                      <b-form-radio
                        v-model="inlineattachment"
                        name="inlineattach"
                        value="Yes"
                      >
                        Yes
                      </b-form-radio>
                      <b-form-radio
                        v-model="inlineattachment"
                        name="inlineattach"
                        value="No"
                      >
                        No
                      </b-form-radio>
                    </b-form-group>

                    <b-modal centered id="inlinemodal" ok-only button-size="lg">
                      <div>
                        <p>Image Uploaded Successfully. Copy the Link below</p>
                        <code class="p-2 m-2 w-100 copyinline" id="copyinline">
                          <p class="copytext">{{ inlineattachmentfile }}</p>
                          <b-icon-folder
                            @click="copylink()"
                            class="copyicon"
                            font-scale="2"
                          ></b-icon-folder>
                        </code>
                        <p>And paste in the Image link field.</p>
                        <b-form-input
                          @input="copynow()"
                          v-model="copytext"
                          class="copier"
                          id="copier"
                        ></b-form-input>
                      </div>
                    </b-modal>

                    <b-overlay :show="uploadinginlineimage">
                      <template #overlay>
                        <div class="text-center">
                          <b-icon-file-image
                            font-scale="3"
                            animation="throb"
                          ></b-icon-file-image>
                          <p>Uploading Image...</p>
                        </div>
                      </template>
                      <b-form-group
                        v-if="inlineattachment == 'Yes'"
                        label="Choose the file and Drop it here.  Then Copy the link after Uploading and Paste in the Link Field of the Image Property"
                      >
                        <b-form-file
                          v-model="question.attachmentlink"
                          v-if="inlineattachment == 'Yes'"
                          ref="inlinefile"
                          placeholder="Choose a file or drop it here."
                          drop-placeholder="Drop File here..."
                          @input="handleInlineImage"
                        ></b-form-file>
                      </b-form-group>
                      <img
                        :src="inlineattachmentfile"
                        v-if="inlineattachment == 'Yes'"
                        class="image-attachment"
                      />
                    </b-overlay>

                    <div v-if="(!$route.params.trackid && !fetching) || ($route.params.trackid && !fetching)">
                      <b-form-group label="Input Question" label-for="question">
                        <vue2-tinymce-editor
                          v-model="question.question"
                        ></vue2-tinymce-editor>
                      </b-form-group>
      
                      <div v-if="question.structure == 'MCQ'">
                          <b-form-group label="Option A" label-for="optiona">
                            <vue2-tinymce-editor
                              v-model="question.optionA"
                            ></vue2-tinymce-editor>
                          </b-form-group>
        
                          <b-form-group label="Option B" label-for="optionb">
                            <vue2-tinymce-editor
                              v-model="question.optionB"
                            ></vue2-tinymce-editor>
                          </b-form-group>
        
                          <b-form-group label="Option C" label-for="optionc">
                            <vue2-tinymce-editor
                              v-model="question.optionC"
                            ></vue2-tinymce-editor>
                          </b-form-group>
        
                          <b-form-group label="Option D" label-for="optiond">
                            <vue2-tinymce-editor
                              v-model="question.optionD"
                            ></vue2-tinymce-editor>
                          </b-form-group>
        
                          <b-form-group label="Option E (Optional)" label-for="optione">
                            <vue2-tinymce-editor
                              v-model="question.optionE"
                            ></vue2-tinymce-editor>
                          </b-form-group> 
                          
                          <b-form-group label="Correct Option" label-for="correct">
                            <b-form-select
                              id="correct"
                              :options="options"
                              v-model="question.correct"
                              required
                            />
                          </b-form-group>
                      </div>
                    
                    </div>

                      

                    <div v-if="question.structure == 'OEQ'">
                      <b-form-group label="OEQ Text Answer">
                        <b-form-input
                          v-model="question.oeqanswer"
                          placeholder="Answer"
                        ></b-form-input>
                      </b-form-group>
                    </div>

                    <b-form-group label="Is there a Solution?">
                      <b-form-radio
                        v-model="question.isSolution"
                        name="solatt"
                        :value="true"
                      >
                        Yes
                      </b-form-radio>
                      <b-form-radio
                        v-model="question.isSolution"
                        name="solatt"
                        :value="false"
                      >
                        No
                      </b-form-radio>
                    </b-form-group>

                    <b-form-group
                      v-if="question.isSolution == 'Yes' || question.isSolution"
                      label="Solution Type"
                    >
                      <b-form-select v-model="question.solutiontype">
                        <b-form-select-option value="null"
                          >--Solution Type--</b-form-select-option
                        >
                        <b-form-select-option value="Text"
                          >Text</b-form-select-option
                        >
                        <b-form-select-option value="Image"
                          >Image</b-form-select-option
                        >
                      </b-form-select>
                    </b-form-group>

                    <b-form-group
                      v-if="
                        question.solutiontype == 'Text' &&
                          (question.isSolution == 'Yes' || question.isSolution)
                      "
                      label="Solution"
                      label-for="solution"
                    >
                      <vue2-tinymce-editor
                        v-model="question.solution"
                      ></vue2-tinymce-editor>
                    </b-form-group>
                    <b-overlay :show="uploadingqimage">
                      <template #overlay>
                        <div class="text-center">
                          <b-icon-file-image
                            font-scale="3"
                            animation="throb"
                          ></b-icon-file-image>
                          <p>Uploading Image...</p>
                        </div>
                      </template>
                      <b-form-group
                        v-if="
                          question.solutiontype == 'Image' &&
                            (question.isSolution == 'Yes' || question.isSolution)
                        "
                        label="Solution Image"
                      >
                        <b-form-file
                          v-model="solutionlink"
                          ref="sfile"
                          placeholder="Choose a file or drop it here"
                          drop-placeholder="Drop File here..."
                          @input="handleSolutionimage"
                        ></b-form-file>
                      </b-form-group>
                      <img
                        :src="solutionlink"
                        v-if="
                          question.solutiontype == 'Image' &&
                            (question.isSolution == 'Yes' || question.isSolution)
                        "
                        class="image-attachment mb-3"
                      />
                    </b-overlay>

                    <div class="mt-3 mb-3">
                      <p class="form-label">Add Tags to Question</p>
                      <div class="row mt-2" v-for="tag,index in tags" :key="index">
                          <div class="col-lg-5">
                            <b-form-select
                              id="selectsbuject"
                              class="form-inp"
                              :options="tagsArray"
                              v-model="tag.name"
                              label="Select Tags"
                              required
                            >
                              <b-form-select-option value="null"
                                >--Select Tags--</b-form-select-option
                              >
                            </b-form-select>
      
                          </div>
      
                          <div class="col-lg-5">
                            <b-form-select
                              v-if="tag.name == 'Year'"
                              id="selectsbuject"
                              class="form-inp"
                              :options="yearArray"
                              v-model="tag.value"
                              label="Select Year"
                              required
                            >
                              <b-form-select-option value="null"
                                >--Select Year--</b-form-select-option
                              >
                            </b-form-select>
      
                            <b-form-select
                              v-if="tag.name == 'Difficulty'"
                              id="selectsbuject"
                              class="form-inp"
                              :options="difficultyArray"
                              v-model="tag.value"
                              label="Select Difficulty"
                              required
                            >
                              <b-form-select-option value="null"
                                >--Select Difficulty--</b-form-select-option
                              >
                            </b-form-select>
      
                            <b-form-select
                              v-if="tag.name == 'Experience'" 
                              id="selectsbuject"
                              class="form-inp"
                              :options="experienceArray"
                              v-model="tag.value"
                              label="Select Experience"
                              required
                            >
                              <b-form-select-option value="null"
                                >--Select Experience--</b-form-select-option
                              >
                            </b-form-select>
                          </div>
                          <div class="col-lg-2">
                            <b-icon-trash-fill scale="1.5" class="mt-1" v-if="tags.length > index + 1" @click="removeTag(index)"></b-icon-trash-fill>
                            <div class="flex gap-4">
                              <b-icon-plus-circle class="mt-1" scale="1.5" v-if="tags.length == (index + 1)" @click="addNewTag()"></b-icon-plus-circle>
                            </div>
      
                          </div>
                      </div>
                      
                    </div>
                    <b-form-group label="Topic Reference">
                      <b-form-input
                        v-model="question.topicref"
                        placeholder="Topic Reference"
                      ></b-form-input>
                    </b-form-group>

                    <div v-if="uploaded" class="alert alert-success p-3">
                      Question Uploaded
                    </div>

                    <b-row>
                      <b-col></b-col>
                      <b-col md="6">
                        <b-form-group class="text-center">
                          <b-overlay
                            :show="uploading"
                            rounded
                            opacity="0.6"
                            spinner-small
                            spinner-variant="primary"
                            class=""
                          >
                            <b-button
                              :disabled="empties"
                              type="submit"
                              class="btn-sub p-1 w-50"
                              variant="success"
                            >
                              {{ $route.params.trackid ? 'Update Question' : "Submit Question"}}
                            </b-button>
                          </b-overlay>
                        </b-form-group>
                      </b-col>
                      <b-col> </b-col>
                    </b-row>
                  </b-form-group>
                </b-card>
              </b-overlay>
            </form>
          </b-col>
          <b-col v-if="uploadmethod == 'File'">
            <b-card>
              <div class="sqheader p-2 m-1">
                <div class="heasub mt-2 ml-3">
                  <h6>View .txt File Formatting Rules</h6>
                </div>
                <div class="sqicon">
                  <b-icon-plus
                    font-scale="1.8"
                    v-if="showplus"
                    @click="
                      showplus = false;
                      showformatting = true;
                      showminus = true;
                    "
                    class="sqbicon"
                  ></b-icon-plus>

                  <b-icon-dash
                    font-scale="1.8"
                    v-if="showminus"
                    @click="
                      showformatting = false;
                      showminus = false;
                      showplus = true;
                    "
                    class="sqbicon"
                  ></b-icon-dash>
                </div>
              </div>
              <div v-if="showformatting">
                <div class="text-center">
                  <h1 class="text-center">
                    Showing Format for {{ showstructure }} Questions
                  </h1>
                  <b-button-group size="sm" class="text-center mb-3">
                    <b-button
                      variant="primary"
                      @click="showstructure = 'MCQ'"
                      :class="
                        showstructure == 'MCQ' ? 'active-method' : 'inactive-method'
                      "
                      >MCQ Format</b-button
                    >
                    <b-button
                      variant="primary"
                      @click="showstructure = 'OEQ'"
                      class="up-btn"
                      :class="
                        showstructure == 'OEQ' ? 'active-method' : 'inactive-method'
                      "
                      >OEQ Format</b-button
                    >
                  </b-button-group>
                </div>

                <ul>
                  <li>
                    A question block starts from the question line of a question
                    within the question file to the seperating Line to another
                    question
                  </li>
                  <li>
                    Every Field must be in a New line
                  </li>
                  <li>
                    Any Field not tagged (Optional) must be inserted in each
                    question block in the file.
                  </li>
                  <li>
                    Optional Field must be inserted in the question blocks in the
                    order shown in the format below
                  </li>
                  <li>
                    Each field must not span two lines. If there's a need for a new
                    line within a field (e.g Solutions/Explanations) the line break
                    character &lt;br&gt; should be placed at that point within the
                    solution. If there's any need for a paragragh use
                    &lt;br&gt;&lt;br&gt;
                  </li>
                  <li>
                    Cross Check Question File before uploading, ensure every
                    question block spans thesame number of lines throughout and each
                    meets the configuration you are uploading with (e.g Is there
                    Solution, is there Image Attachment etc)
                  </li>
                </ul>

                <div v-if="showstructure == 'MCQ'">
                  <h4 class="mt-3">
                    Good .txt File Formatting Method for adding Questions
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">Question</p>
                      <p class="txtformat">Option A</p>
                      <p class="txtformat">Option B</p>
                      <p class="txtformat">Option C</p>
                      <p class="txtformat">Option D</p>
                      <p class="txtformat">
                        Option E(If any, If no option E, leave line empty)
                      </p>
                      <p class="txtformat">Correct Option</p>
                      <p class="txtformat">Solution (Optional)</p>
                      <p class="txtformat">Topic Reference (Optional)</p>
                      <p class="txtformat">
                        spirogyra.jpg (Exact Image full name in the Bulk uploaded
                        images) (Optional)
                      </p>
                      <p class="txtformat">Seperating line</p>
                    </code>
                  </b-card>
                  <h4 class="mt-3">
                    Good .txt File Formatting Method for adding Questions (Example)
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">
                        What is the empirical difference between a Wall Gecko that
                        climbs the wall and a green snake that walks through the
                        desert with its belly on the ground
                      </p>
                      <p class="txtformat">
                        the snake and the gecko are 3mH and 5mH different
                      </p>
                      <p class="txtformat">
                        the snake is 3mH faster than the gecko
                      </p>
                      <p class="txtformat">
                        the gecko is 0.5mH slower than the snake
                      </p>
                      <p class="txtformat">
                        the snake and the gecko are both at the same pace
                      </p>
                      <p class="txtformat"><br /></p>
                      <p class="txtformat">C</p>
                      <p class="txtformat">
                        As we know that a snake is an animal or preferably to say a
                        reptile which is also a Phylum of the animal Kingdom which
                        moves on its belly. A snake also moves by way of sensing
                        vibrations and its a terror to its prey. A Gecko is also an
                        animal of the same kingdom bla bla bla
                      </p>
                      <p class="txtformat">Animal Kingdom</p>
                      <p class="txtformat">spirogyra.jpeg</p>
                      <p class="txtformat"><br /></p>
                    </code>
                  </b-card>
                  <h4 class="mt-3">
                    Bad .txt File Formatting Method for adding Questions (Example)
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">
                        1) what is the empirical difference between a Wall Gecko
                        that climbs the wall and a green snake that walks through
                        the desert with its belly on the ground
                      </p>
                      <p class="txtformat">
                        a) the snake and the gecko are 3mH and 5mH different
                      </p>
                      <p class="txtformat">
                        b) the snake is 3mH faster than the gecko
                      </p>
                      <p class="txtformat">
                        c) the gecko is 0.5mH slower than the snake
                      </p>
                      <p class="txtformat">
                        d)the snake and the gecko are both at the same pace
                      </p>
                      <p class="txtformat">e)</p>
                      <p class="txtformat">Correct : C</p>
                      <p class="txtformat">
                        Solution: As we know that a snake is an animal or preferably
                        to say a reptile which is also a Phylum of the animal
                        Kingdom which moves on its belly. A snake also moves by way
                        of sensing vibrations and its a terror to its prey. A Gecko
                        is also an animal of the same kingdom bla bla bla
                      </p>
                      <p class="txtformat">Topic : Animal Kingdom</p>
                      <p class="txtformat">Image : spirogyra.jpeg</p>
                      <p class="txtformat"><br /></p>
                    </code>
                  </b-card>
                </div>

                <div v-if="showstructure == 'OEQ'">
                  <h4 class="mt-3">
                    Good .txt File Formatting Method for adding Questions
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">Question</p>
                      <p class="txtformat">Answer</p>
                      <p class="txtformat">Solution (Optional)</p>
                      <p class="txtformat">Topic Reference (Optional)</p>
                      <p class="txtformat">
                        spirogyra.jpg (Exact Image full name in the Bulk uploaded
                        images) (Optional)
                      </p>
                      <p class="txtformat">Seperating line</p>
                    </code>
                  </b-card>
                  <h4 class="mt-3">
                    Good .txt File Formatting Method for adding Questions
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">
                        When was the UN Rights Declaration made?
                      </p>
                      <p class="txtformat">1945</p>
                      <p class="txtformat">
                        After the World War II, the United Nations Organization came
                        up with a 7 page Human rights declaration to stem the
                        occurence of another World War
                      </p>
                      <p class="txtformat">Human Rights</p>
                      <p class="txtformat">spirogyra.jpeg</p>
                      <p class="txtformat"><br /></p>
                    </code>
                  </b-card>
                  <h4 class="mt-3">
                    Bad .txt File Formatting Method for adding Questions
                  </h4>
                  <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code>
                      <p class="txtformat">
                        1) When was the UN Rights Declaration made?
                      </p>
                      <p class="txtformat">Answer : 1945</p>
                      <p class="txtformat">
                        After the World War II, the United Nations Organization came
                        up with a 7 page Human rights declaration to stem the
                        occurence of another World War
                      </p>
                      <p class="txtformat">Topic : Human Rights</p>
                      <p class="txtformat">Image : spirogyra.jpeg</p>
                      <p class="txtformat"><br /></p>
                    </code>
                  </b-card>
                </div>
              </div>

              <div>
                <div v-if="mtype == 'added'" class="alert alert-success">
                  All Question{{ questionscount > 1 ? "s" : "" }} has been added to
                  the database. Go to
                  <b-link :to="{ name: 'listquestion' }"
                    >Edit Question to confirm.</b-link
                  >
                </div>
                <b-form-group>
                  <b-form-group label="Select category" label-for="category">
                    <b-form-select
                      id="category"
                      :options="categoryarray"
                      v-model="question.category"
                      @change="categoryChanged"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select category--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="sameName != 'Yes'"
                    label="Institution/University"
                    label-for="selectinstitution"
                  >
                    <b-form-select
                      id="selectinstitution"
                      class="form-inp"
                      :options="institutionsarray"
                      v-model="question.institution_id"
                      @change="institutionChanged"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Institution--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="structure == 'Section' && question.institution != null"
                    label="Select Level"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.level"
                      @change="chgCourses"
                      :options="levelarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Level--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="
                      structure == 'Section' &&
                        question.institution != null &&
                        question.level != null
                    "
                    label="Select Course"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.course"
                      @change="chgSection"
                      :options="coursesarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Course--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    class="nested-form-group"
                    v-if="
                      structure == 'Section' &&
                        question.institution != null &&
                        question.level != null &&
                        question.course != null
                    "
                    label="Select Section"
                    label-for="institution"
                  >
                    <b-form-select
                      v-model="question.section"
                      :options="sectionarray"
                    >
                      <b-form-select-option value="null"
                        >--Select Section--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    v-if="structure == 'Subject'"
                    label="Select Subject"
                    label-for="selectsubject"
                  >
                    <b-form-select
                      id="selectsbuject"
                      class="form-inp"
                      :options="subjectsarray"
                      v-model="question.subject"
                      label="Select Subject"
                      required
                    >
                      <b-form-select-option value="null"
                        >--Select Subject--</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group
                    label="Select Question Structure"
                    label-for="correct"
                  >
                    <b-form-select
                      id="correct"
                      :options="structureoptions"
                      v-model="question.structure"
                      required
                    />
                  </b-form-group>

                  <b-form-group label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">Are these 'Read the Passage' Questions?</p>
                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-1"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-1"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*All Questions in this File Must be related to the
                          Passage.</span
                        ><br />
                        <span class="info-span"
                          >*The Passage should not be included to any question in
                          the File but should be typed or pasted in the Passage
                          Field that would be displayed below</span
                        >
                      </b-tooltip>
                    </div>
                    <b-form-radio
                      v-model="question.isPassage"
                      name="ispassage"
                      :value="true"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isPassage"
                      name="ispassage"
                      :value="false"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    label="Paste the Passage below"
                    label-for="passage"
                    v-if="question.isPassage == 'Yes' || question.isPassage"
                  >
                    <vue2-tinymce-editor
                      v-model="question.passage"
                    ></vue2-tinymce-editor>
                  </b-form-group>

                  <b-form-group label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">
                        Are there Solutions for Questions in these File?
                      </p>
                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-2"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-2"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*If Yes is choosen, every question on this Question File
                          must contain a Solution</span
                        ><br />
                        <span class="info-span"
                          >*If No is choosen, no question must contain a
                          Solution</span
                        >
                      </b-tooltip>
                    </div>
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      :value="true"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isSolution"
                      name="solatt"
                      :value="false"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group
                    v-if="question.isSolution == 'Yes' || question.isSolution"
                    label=""
                  >
                    <div class="tooltip-wrapper">
                      <p class="form-label">Solution Type</p>
                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-3"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-3"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*Only Text Solution type has support by File Upload</span
                        >
                      </b-tooltip>
                    </div>

                    <b-form-select v-model="question.solutiontype">
                      <b-form-select-option value="null"
                        >--Solution Type--</b-form-select-option
                      >
                      <b-form-select-option value="Text">Text</b-form-select-option>
                      <b-form-select-option disabled value="Image"
                        >Image</b-form-select-option
                      >
                    </b-form-select>
                  </b-form-group>

                  <b-form-group label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">
                        Are there Topic References in this Question File?
                      </p>
                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-topic"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-topic"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*If Yes is choosen, every question in this Question File
                          must contain a topic reference Line</span
                        ><br />
                        <span class="info-span"
                          >*If No is choosen, no question must contain a topic
                          reference line</span
                        >
                      </b-tooltip>
                    </div>
                    <b-form-radio
                      v-model="question.isTopicReference"
                      name="solatttopic"
                      :value="true"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isTopicReference"
                      name="solatttopic"
                      :value="false"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <b-form-group label="">
                    <div class="tooltip-wrapper">
                      <p class="form-label">
                        Questions with Image attachments? (Bulk Image Upload)
                      </p>
                      <b-icon-info-circle-fill
                        id="tooltip-morelabels-4"
                        class="mt-2 cursor-pointer"
                      ></b-icon-info-circle-fill>
                      <b-tooltip
                        target="tooltip-morelabels-4"
                        custom-class="tooltip"
                        style="width: 500px"
                        triggers="hover"
                      >
                        <span class="info-span"
                          >*If Yes is choosen, EVERY question in this File must have
                          an image expected to be attached with the question</span
                        ><br />
                        <span class="info-span"
                          >*If No is choosen, no question must contain an
                          Attachment</span
                        >
                      </b-tooltip>
                    </div>

                    <b-form-radio
                      v-model="question.isAttachment"
                      name="isattachment"
                      :value="true"
                    >
                      Yes
                    </b-form-radio>
                    <b-form-radio
                      v-model="question.isAttachment"
                      name="isattachment"
                      :value="false"
                    >
                      No
                    </b-form-radio>
                  </b-form-group>

                  <div
                    v-if="question.isAttachment == 'Yes' || question.isAttachment"
                  >
                    <b-overlay :show="uploadingimages">
                      <template #overlay>
                        <div class="text-center">
                          <b-icon-file-image
                            font-scale="3"
                            animation="throb"
                          ></b-icon-file-image>
                          <p>Uploading Images... Checking Semantics</p>
                        </div>
                      </template>
                      <b-form-group label="Upload Bulk Images">
                        <b-form-file
                          :disabled="chkentries"
                          variant="warning"
                          v-model="imageslink"
                          ref="imagesfiles"
                          multiple
                          placeholder="Select all the image files or drag and drop them here"
                          drop-placeholder="Drop Files here..."
                          @input="handleAttachemntFileUpload"
                        ></b-form-file>
                      </b-form-group>
                    </b-overlay>
                    <div v-if="mtypeimages == 'Ready!'" class="alert alert-success">
                      {{ uploadimagesmessage }}
                    </div>
                  </div>

                  <div class="mt-3 mb-3">
                    <p class="form-label">Add Tags to Question</p>
                    <div class="row mt-2" v-for="tag,index in tags" :key="index">
                        <div class="col-lg-5">
                          <b-form-select
                            id="selectsbuject"
                            class="form-inp"
                            :options="tagsArray"
                            v-model="tag.name"
                            label="Select Tags"
                            required
                          >
                            <b-form-select-option value="null"
                              >--Select Tags--</b-form-select-option
                            >
                          </b-form-select>

                        </div>

                        <div class="col-lg-5">
                          <b-form-select
                            v-if="tag.name == 'Year'"
                            id="selectsbuject"
                            class="form-inp"
                            :options="yearArray"
                            v-model="tag.value"
                            label="Select Year"
                            required
                          >
                            <b-form-select-option value="null"
                              >--Select Year--</b-form-select-option
                            >
                          </b-form-select>

                          <b-form-select
                            v-if="tag.name == 'Difficulty'"
                            id="selectsbuject"
                            class="form-inp"
                            :options="difficultyArray"
                            v-model="tag.value"
                            label="Select Difficulty"
                            required
                          >
                            <b-form-select-option value="null"
                              >--Select Difficulty--</b-form-select-option
                            >
                          </b-form-select>

                          <b-form-select
                            v-if="tag.name == 'Experience'" 
                            id="selectsbuject"
                            class="form-inp"
                            :options="experienceArray"
                            v-model="tag.value"
                            label="Select Experience"
                            required
                          >
                            <b-form-select-option value="null"
                              >--Select Experience--</b-form-select-option
                            >
                          </b-form-select>
                        </div>
                        <div class="col-lg-2">
                          <b-icon-trash-fill scale="1.5" class="mt-1" v-if="tags.length > index + 1" @click="removeTag(index)"></b-icon-trash-fill>
                          <div class="flex gap-4">
                            <b-icon-plus-circle class="mt-1" scale="1.5" v-if="tags.length == (index + 1)" @click="addNewTag()"></b-icon-plus-circle>
                          </div>

                        </div>
                    </div>
                    
                  </div>

                  <b-form-group
                    label="How many Questions are being Uploaded?"
                    label-for="markper"
                  >
                    <b-form-spinbutton
                      id="markper"
                      v-model="questionsinfile"
                      min="1"
                      max="2000"
                      step="1"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-form-group>
              </div>

              <div v-if="!hideFileBox" class="mt-5">
                <div
                  style="display:flex; justify-content:space-between"
                  class="w-100"
                >
                  <h3 class="">
                    Upload {{ mtype == "added" ? "another" : "" }} Question File
                    <b-icon-cloud-upload></b-icon-cloud-upload>
                  </h3>

                  <div class="mt-2 underline">
                    <a
                      :href="
                        `${origin}/files/csv/candidates/candidates-1IbF2h6FjpLoFtj2RId3FWfiRAMQ2Bn8d63kykT7.csv`
                      "
                      download
                    >
                      Download Example File (.txt)
                    </a>
                  </div>
                </div>

                <b-overlay :show="uploadingfile">
                  <template #overlay>
                    <div class="text-center">
                      <b-icon-file-image
                        font-scale="3"
                        animation="throb"
                      ></b-icon-file-image>
                      <p>Uploading File... Checking Semantics</p>
                    </div>
                  </template>

                  <div @click="triggerFileClick()" class="file-upload-box">
                    <h4 class="text-center m-3">
                      Upload {{ mtype == "added" ? "another" : "" }} File
                      (.txt)
                      <b-icon-cloud-upload></b-icon-cloud-upload>
                    </h4>
                    <h6 class="text-center">Click inside the box to upload</h6>

                    <input
                      hidden
                      v-if="!uploadingfile"
                      type="file"
                      ref="questionfile"
                      @input="handleFileUpload"
                      class="profile-photo-input"
                    />
                  </div>
                </b-overlay>
              </div>

              <div class="mt-3" v-if="mtype == 'Ready!'">

                <div
                  class="alert"
                  :class="countsynced == true ? 'alert-success' : 'alert-danger'"
                >
                  {{ uploadmessage }}
                </div>

                <div
                  style="display:flex; justify-content:space-between"
                  class="w-100"
                >
                  <h3 class="">
                    There are {{ questionscount }} Question{{
                      questionscount > 1 ? "s" : ""
                    }}
                    in this File
                  </h3>

                  <div
                    style="display:flex; justify-content:flex-end; gap: 20px"
                    class="mt-2"
                  >
                    <div
                      @click="showPreview = false"
                      class="leftPreview"
                      style="display:flex;flex-wrap:no-wrap; gap: 10px;cursor:pointer"
                      v-if="showPreview"
                    >
                      <p>Hide Preview</p>
                      <b-icon-eye-slash class="mt-1"></b-icon-eye-slash>
                    </div>
                    <div
                      @click="showPreview = true"
                      class="leftPreview"
                      style="display:flex;flex-wrap:no-wrap; gap: 10px;cursor:pointer"
                      v-if="!showPreview"
                    >
                      <p>Show Preview</p>
                      <b-icon-eye class="mt-1"></b-icon-eye>
                    </div>

                    <div
                      class="leftPreview"
                      style="display:flex;flex-wrap:no-wrap; gap: 10px;cursor:pointer"
                      @click="
                        (showPreview = false),
                          (hideFileBox = false),
                          (uploadedfile = false),
                          (mtype = 'upload')
                      "
                    >
                      <p>Upload again</p>
                      <b-icon-cloud-upload class="mt-1"></b-icon-cloud-upload>
                    </div>
                  </div>
                </div>

                <div v-if="showPreview" class="sqheader p-2 m-1">
                  <div class="heasub px-2">
                    <p class="bs-text mt-2">
                      Review the Question{{ questionscount > 1 ? "s" : "" }} before
                      Adding them to the Database
                    </p>
                  </div>
                </div>

                <div style="overflow-x: auto;" class="mt-3" v-if="showPreview">
                  <div style="display:flex; justify-content:flex-start; gap: 10px">
                    <div
                      class=""
                      v-for="(question, index) in allquestions"
                      :key="index"
                    >
                      <QuestionsForList
                        :key="index"
                        :question="question"
                        :module="'thirdparty'"
                        :sn="index + 1"
                        display="view"
                        class="questions-lister"
                      />
                    </div>
                  </div>
                  <!-- <b-card class="txtcode" bg-variant="dark" text-variant="light">
                    <code v-html="reviewupload"> </code>
                  </b-card> -->
                </div>

                <b-form-group class="text-center mt-3">
                  <b-overlay
                    :show="adding"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class=""
                  >
                    <b-button
                      :disabled="!countsynced"
                      @click="addFileQuestions"
                      size="lg"
                      type="submit"
                      class="p-1 w-50"
                      variant="success"
                    >
                      Add Questions to Database
                    </b-button>
                  </b-overlay>
                </b-form-group>

                <b-button
                  v-if="adding"
                  class="w-50 p-2 mt-3 btntxt"
                  variant="dark"
                  @click="stopproceed"
                >
                  Cancel
                </b-button>
              </div>

              <div
                style="display:flex;flex-wrap:no-wrap; justify-content:space-between"
                class="w-100"
                v-if="mtype == 'added'"
              >
                <h4 class="">
                  All {{ questionscount }} Question{{
                    questionscount > 1 ? "s" : ""
                  }}
                  Have been uploaded
                </h4>

                <div
                  style="display:flex;flex-wrap:no-wrap; justify-content:flex-end; gap: 10px"
                  class="mt-2"
                >
                  <div
                    class="leftPreview"
                    style="display:flex;flex-wrap:no-wrap; gap: 10px;cursor:pointer"
                    @click="
                      (showPreview = false),
                        (hideFileBox = false),
                        (uploadedfile = false),
                        (mtype = 'upload')
                    "
                  >
                    <p>Upload Another</p>
                    <b-icon-cloud-upload class="mt-1"></b-icon-cloud-upload>
                  </div>
                </div>
              </div>

              <div v-if="mtype == 'added'" class="alert alert-success mt-4">
                All Question{{ questionscount > 1 ? "s" : "" }} has been added to
                the database.
                <b-link :to="{ name: 'listquestion' }"
                  >View Uploaded Questions</b-link
                >
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-overlay>
  </b-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import store from "@/store";
import axios from "axios";
import { Vue2TinymceEditor } from "vue2-tinymce-editor";
import QuestionsForList from "@/components/admin/QuestionsForList.vue";

export default {
  components: {
    Vue2TinymceEditor,
    QuestionsForList
  },
  data() {
    return {
      questionsinfile: 1,
      showformatting: false,
      uploadmethod: "Text",
      inlineattachmentfile: "",
      inlineattachment: "No",
      copytext: "",
      showcopy: false,
      emptyin: this.empties,
      leaving: false,
      uploaded: false,
      dismissCountDown: 60,
      subjectsarray: [],
      categoryarray: [],
      options: [
        {
          value: null,
          text: "--Choose Correct Option--"
        },
        {
          value: "A",
          text: "A"
        },
        {
          value: "B",
          text: "B"
        },
        {
          value: "C",
          text: "C"
        },
        {
          value: "D",
          text: "D"
        },
        {
          value: "E",
          text: "E"
        }
      ],
      structureoptions: [
        {
          value: null,
          text: "--Choose question structure--"
        },
        {
          value: "MCQ",
          text: "MCQ (Multiple Choice Questions)"
        },
        {
          value: "OEQ",
          text: "OEQ (Open-ended Questions)"
        }
      ],
      levelarray: [],
      coursesarray: [],
      sectionarray: [],
      scholarshiptypearr: [],
      institutionsarray: [],
      question: this.getForm(),
      sent: false,
      uploading: false,
      attachmentfiles: "",
      uploadingqimage: false,
      uploadinginlineimage: false,
      filelink: "",
      solutionlink: "",
      reviewupload: "",
      questionscount: 0,
      filedir: "",
      mtype: "",
      uploadingfile: false,
      uploadedfile: false,
      adding: false,
      showminus: false,
      showplus: true,
      showminus2: true,
      showplus2: false,
      uploadmessage: "",
      countsynced: false,
      showreview: true,
      org: "",
      orgId: "",
      structure: "",
      sameName: "",
      url: "",
      status: "",
      imageslink: "",
      imagesdir: "",
      folderdir: "",
      uploadingimages: false,
      uploadimagesmessage: "",
      mtypeimages: "",
      showstructure: "MCQ",
      tags: [
        {
          name: null,
          value: null
        }
      ],
      tagsArray : ["Year", "Difficulty", "Experience"],
      difficultyArray : ["Easy", "Medium", "Hard", "Very Difficult", "Expert"],
      experienceArray : ["Beginner", "Junior", "Mid-level", "Intermediate", "Senior", "Advanced", "Master"],
      fetching: false,
      questionupdated: false,
      hideFileBox: false,
      allquestions: []
    };
  },
  beforeRouteEnter(to, from, next) {
    //NProgress.start()
    store.dispatch("admin/fetchInstitutions");
    store.dispatch("admin/fetchCategories");

    //NProgress.done()
    next();
  },

  async mounted() {
    
    this.setImageDirectory("questions");
    this.setCurrentModule("Questions");
    
    document.title = "Quicktest || Upload Questions"
    // let cklink = this.environ == 'development' ? "http://localhost/quicktest/plugins/ckeditor/ckeditor.js" : "https://quicktest.futavilla.com/js/ckeditor/ckeditor.js"
    // this.editorUrl = cklink

    this.org = this.details.clearance_organization;
    this.orgId = this.details.clearance_organization_id;

    if (!this.loggedin) {
      this.$router.push({
        name: "login"
      });
    }
    if (this.details.clearance == "Normal") {
      this.$router.push({
        name: "welcome"
      });
    }
    // let inst = this.allinsti.map((x) => x.name);
    await store.dispatch("admin/fetchInstitutions");
    await store.dispatch("admin/fetchCategories");
    let typesarr = this.Categories.map(x => x.name);
    this.categoryarray = typesarr;

    if (this.$route.params.trackid) {
        this.fetchQuestionApi()
    }
  },
  methods: {
    triggerFileClick() {

      if(this.chkentries){
        this.$bvToast.toast(`Select all Required Fields before Uploading File`, {
          title: `An Error Occured`,
          variant: "danger",
          solid: true
        });
        
      }else{
        this.$refs.questionfile.click();
      }

    },
    removeTag(index){
      this.tags = this.tags?.splice(index, 1);
    },
    addNewTag(){
      this.tags.push({ name : null, value : null})
    },
    async fetchQuestionApi(){
      this.fetching = true

      try {
        const response = await this.fetchQuestion2(this.$route.params.trackid);

        const question = response.data

        let institution = this.allinsti.find(
          x => x.track_id == question.institution_id
        );
        this.structure = institution.structure;

        let inst = this.allinsti
          .filter(
            x =>
              x.category == question.category &&
              x.organization_trackid == question.organization_id
          )
          .map(x => ({ text: x.name, value: x.track_id }))
        this.institutionsarray = inst;

        if (this.structure == "Section") {
          let levell = JSON.parse(institution.levels_config);
          this.levelarray = levell.map(x => x.name);

          // Get the Chosen Level exact config Array
          let config = levell.find(x => x.name == question.level)
            .config;
          // Now get the Courses from the courses Object of the Chosen level exact config Object
          let courses = config.find(x => x.name == "courses").values;

          this.coursesarray = courses;

          this.question.institution = institution.name;

          let sections = config.find(x => x.name == "sectionsperc").values;

          let courseindex = this.coursesarray.indexOf(
            question.course
          );
          let nsections = sections[courseindex];
          let sectarr = Array();

          for (let i = 0; i < nsections; i++) {
            let alpha = Array(
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K"
            );
            sectarr.push("Section " + alpha[i]);
          }

          this.sectionarray = sectarr;
        } else {
          let subbb = this.allinsti
            .filter(x => x.name == question.institution)
            .map(x => x.subjects_offered);
          this.subjectsarray = JSON.parse(subbb);
        }

        this.attachmentfiles = question.image_link;
        this.solutionlink = question.solution;

        this.tags = question.tags ? JSON.parse(question.tags) : this.tags,

        this.question = {
          institution: institution.name,
          institution_id: institution.track_id,
          subject: question.subject,
          tags: JSON.parse(question.tags),
          category: question.category,
          level: question.level,
          course: question.course,
          section: question.section,
          question: question.question,
          structure: question.structure,
          oeqanswer: question.oeq_answer,
          optionA: question.a,
          optionB: question.b,
          optionC: question.c,
          optionD: question.d,
          optionE: question.e,
          correct: question.correct,
          isSolution: JSON.parse(question.isSolution),
          solutiontype: question.solutiontype,
          solution: question.solution,
          scholarshiptype: "",
          isAttachment: JSON.parse(question.isAttachment),
          isTopicReference: JSON.parse(question.isTopicReference),
          attachmentfile: question.image_link,
          trackid: question.track_id,
          isPassage: JSON.parse(question.isPassage),
          passage: question.passage,
          topicref: question.topic_reference
        };
        this.fetching = false
      }catch(err){
        console.log(err)
        this.fetching = false
      }
    },
    handleImage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.file.files[0];
      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.filelink = this.url;
          this.filelink = this.url;
          this.setFile(this.url);
          this.attachmentfiles = this.url;
        }
      });
    },
    handleSolutionimage() {
      this.uploadingqimage = true;
      let ifile = this.$refs.sfile.files[0];

      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadingqimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.solutionlink = this.url;
        }
      });
    },
    handleInlineImage() {
      this.uploadinginlineimage = true;
      let ifile = this.$refs.inlinefile.files[0];
      this.imageUpload(ifile).then(() => {
        if (this.status == "success") {
          this.uploadinginlineimage = false;
          this.$bvModal
            .msgBoxOk(
              "Image Uploaded Successfully. Proceed with Question Upload.",
              {
                title: "Image Uploaded",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          this.$bvModal.show("inlinemodal");
          this.filelink = this.url;
          // console.log(this.url);
          //this.setFile(response.data.url);
          this.inlineattachmentfile = this.url;
          this.copytext = this.url;
        }
      });
    },
    async imageUpload(imagefile) {
      this.url = "";
      this.status = "";
      let formData = new FormData();
      formData.append("image", imagefile);
      formData.append("environment", this.environ);
      formData.append("origin", this.origin);
      formData.append("pretag", "questionimage");
      let apilink =
        this.environ == "development"
          ? `${this.origin}/ImageHandler.php`
          : `${this.origin}/ImageHandler.php`;

      return await axios
        .post(apilink, formData, {
          header: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.uploadingqimage = false;
          this.url = response.data.url;
          this.status = "success";
        })
        .catch(() => {
          this.status = "error";
          this.$bvModal
            .msgBoxOk(
              "Check your Network Connection. Could not upload Image.",
              {
                title: "No Network Connection",
                size: "xs",
                centered: true
              }
            )
            .then(() => {});
          //console.log(error);
        });
    },
    handleFileUpload() {
      let filelength = this.$refs.questionfile.files[0].name.length;

      if (filelength > 0) {
        this.uploadingfile = true;
        let ifile = this.$refs.questionfile.files[0];
        let formData = new FormData();

        formData.append("filetoupload", ifile);
        formData.append("uploadcategory", "Question");
        formData.append("environment", this.environ);
        formData.append("blocksinfile", this.questionsinfile);
        formData.append("pretag", "questions");
        formData.append("origin", this.origin);
        formData.set("category", this.question.category);
        formData.set("institution", this.question.institution);
        formData.set("subject", this.question.subject);
        formData.set("structure", this.question.structure);
        formData.set("organization", this.question.organization);
        formData.set("isSolution", this.question.isSolution);
        formData.set("solutiontype", this.question.solutiontype);
        formData.set("isAttachment", this.question.isAttachment);
        formData.set("isTopicReference", this.question.isTopicReference);
        formData.set("imagesdir", this.imagesdir);
        formData.set("folderdir", this.folderdir);
        formData.set("passage", this.question.passage);
        formData.set("level", this.question.level);
        formData.set("course", this.question.course);
        formData.set("section", this.question.section);
        formData.set("isPassage", this.question.isPassage);
        formData.set("adminname", this.question.admin);
        formData.set("admintrackid", this.question.addedbytrackid);
        let apilink =
          this.environ == "development"
            ? `${this.origin}/Filehandler.php`
            : `${this.origin}/Filehandler.php`;

        axios
          .post(apilink, formData, {
            header: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            this.uploadmessage = response.data.message;
            this.uploadingfile = false;
            this.mtype = response.data.mtype;
            this.reviewupload = response.data.stringedblocks;
            this.questionscount = response.data.countblocks;
            this.countsynced = response.data.countedsync;
            this.allquestions = response.data.allquestions;
            this.hideFileBox = true
            this.showPreview = true

            this.filelink = "";
            this.$bvModal
              .msgBoxOk(
                "Question File Uploaded. Check for errors, confirm the number of Questions to be added to the Database and Proceed wiith the Operation at the end of the Review.",
                {
                  title: "Question File Uploaded",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {});
            this.filedir = response.data.filedir;

          })
          .catch((error) => {
            this.$bvModal
              .msgBoxOk(
                `Check your Network Connection. Could not upload Question File. ${error.response}`,
                {
                  title: "No Network Connection",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {
                this.filelink = "";
                this.uploadingfile = false;
              });
          });
      }
    },

    handleAttachemntFileUpload() {
      // let filelength =  this.$refs.questionfile.files[0].name.length
      // console.log(filelength)

      let multilength = this.$refs.imagesfiles.files.length;
      // alert(multilength)

      if (multilength > 0) {
        let formData = new FormData();

        for (var i = 0; i < multilength; i++) {
          let ifile = this.$refs.imagesfiles.files[i];
          formData.append(`imagestoupload[${i}]`, ifile);
        }
        this.uploadingimages = true;
        // let ifile = this.$refs.questionfile.files[0];

        // formData.append("filetoupload", ifile);
        formData.append("uploadcategory", "questions_images");
        formData.append("environment", this.environ);
        formData.append("pretag", "questions_images");
        formData.append("origin", this.origin);
        formData.set("imagescount", multilength);
        let apilink =
          this.environ == "development"
            ? `${this.origin}/Filehandler.php`
            : `${this.origin}/Filehandler.php`;

        axios
          .post(apilink, formData, {
            header: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(response => {
            // console.log(response.data)
            this.uploadimagesmessage = response.data.message;
            this.uploadingimages = false;
            this.mtypeimages = response.data.mtype;
            this.imageslink = "";
            this.$bvModal
              .msgBoxOk(
                "Images has been uploaded in a Folder. Ensure each Question block has the image name only on the 10th Line after the Topic Line.",
                {
                  title: "Images Uploaded",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {});
            this.imagesdir = response.data.filedir;
            this.folderdir = response.data.folderdir;

            //console.log(response.data);
          })
          .catch(() => {
            //console.log(error)
            this.$bvModal
              .msgBoxOk(
                "Check your Network Connection. Could not upload Question File.",
                {
                  title: "No Network Connection",
                  size: "xs",
                  centered: true
                }
              )
              .then(() => {
                this.filelink = "";
                this.uploadingimages = false;
              });
            //console.log(error);
          });
      }
    },

    addFileQuestions() {
      this.adding = true;
      this.countsynced = this.adding;
      this.question.tags = this.tags

      let addObj = {
        adminname: this.$store.state.loginmaster.details.fullname,
        admintrackid: this.$store.state.loginmaster.details.trackid,
        filedir: this.filedir,
        folderdir: this.folderdir,
        origin: this.origin,
        environment: this.environ,
        imagesdir: this.imagesdir,
        questionObj: this.question
      };

      this.setQuestionFileObj(addObj).then(() => {
        this.adding = false;
        this.mtype = "added";
      });
    },

    leaveRoute() {
      this.leaving = true;
      this.$bvToast.toast("Press the Back Button again to Exit", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },
    stayRoute() {
      this.$bvToast.toast("Exiting Canceled", {
        noCloseButton: true,
        solid: true,
        variant: "dark",
        toaster: "b-toaster-bottom-center"
      });
    },

    setQuestion() {
      this.setloader();
      this.sent = true;
      this.question.attachmentfile = this.filelink;
      this.question.tags = this.tags
      // this.question.organization = this.org
      if (this.question.solutiontype == "Image") {
        this.question.solution = this.solutionlink;
      }

      if (this.$route.params.trackid) {
        this.updateQuestion(this.question).then(() => {
          this.questionupdated = true;
          this.uploading = false;
          this.sent = false;
        });
      }else{
        this.addQuestion(this.question).then(() => {
          this.inlineattachmentfile = "";
          this.attachmentfiles = "";
          this.filelink = "";
          this.solutionlink = "";
          this.uploading = false;
          this.uploaded = true;
          this.sent = false;
          this.question.attachment = "No";
          this.question.isSolution = "No";
          this.question.solutiontype = null;
          this.question.solution = "";
          this.question.question = "";
          this.question.optionA = "";
          this.question.optionB = "";
          this.question.optionC = "";
          this.question.optionD = "";
          this.question.optionE = "";
          this.question.correct = null;
          this.question.topicref = "";
        });
      }


    },
    getForm() {
      return {
        organization: this.$store.state.loginmaster.details
          .clearance_organization,
        organization_id: this.$store.state.loginmaster.details
          .clearance_organization_id,
        institution: null,
        institution_id: "",
        subject: null,
        category: "Thirdparty",
        level: null,
        course: null,
        section: null,
        structure: "MCQ",
        oeqanswer: "",
        scholarshiptype: null,
        isAttachment: false,
        attachmentlink: "",
        attachmentfile: this.$store.state.admin.qimageurl,
        passage: "",
        question: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        optionE: "",
        correct: null,
        isSolution: false,
        solutiontype: "Text",
        isTopicReference: false,
        solution: "",
        topicref: "",
        tags: [],
        isPassage: false,
        admin: this.$store.state.loginmaster.details.fullname,
        addedbytrackid: this.$store.state.loginmaster.details.trackid
      };
    },

    chgCourses() {
      this.question.course = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let institution = this.allinsti.find(
        x => x.track_id == this.question.institution_id
      );
      let levell = JSON.parse(institution.levels_config);
      // this.levelarray = levell.map(x => x.name);

      // Get the Chosen Level exact config Array
      let config = levell.find(x => x.name == this.question.level).config;
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let courses = config.find(x => x.name == "courses").values;

      // Inject this Array into the general courses Array for Selection
      this.coursesarray = courses;
    },

    chgSection() {
      this.question.section = null;
      // Get the Whole Config Object of the selected Undergraduate Institution
      let institution = this.allinsti.find(
        x => x.track_id == this.question.institution_id
      );
      let levell = JSON.parse(institution.levels_config);
      // this.levelarray = levell.map(x => x.name);

      // Get the Chosen Level exact config Array
      let config = levell.find(x => x.name == this.question.level).config;
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      // Now get the Courses from the courses Object of the Chosen level exact config Object
      let sections = config.find(x => x.name == "sectionsperc").values;

      let courseindex = this.coursesarray.indexOf(this.question.course);
      let nsections = sections[courseindex];
      let sectarr = Array();

      for (let i = 0; i < nsections; i++) {
        let alpha = Array(
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K"
        );
        sectarr.push("Section " + alpha[i]);
      }

      this.sectionarray = sectarr;
    },

    institutionChanged() {
      let institution = this.allinsti.find(
        x => x.track_id == this.question.institution_id
      );
      this.question.institution = institution.name;
      this.structure = institution.structure;

      if (this.structure == "Section") {
        let levell = JSON.parse(institution.levels_config);
        this.levelarray = levell.map(x => x.name);
      } else {
        this.subjectsarray = JSON.parse(institution.subjects_offered);
      }
    },

    categoryChanged() {
      this.question.institution_id = null; // If the type is changed, reset the select Object. set the institution property to null
      this.question.institution = null; // If the type is changed, reset the select Object. set the institution property to 
      this.institutionsarray = []; // Empties the Institutions Array
      this.topicfor = null;

      let inst = this.allinsti
        .filter(
          x =>
            x.category == this.question.category &&
            x.organization_trackid == this.orgId
        )
        .map(x => ({ text: x.name, value: x.track_id }))
      this.institutionsarray = inst;

      this.question.organization = this.org;

      let sameName = this.Categories.filter(
        x =>
          x.organization_trackid == this.orgId &&
          x.name == this.question.category
      ).map(x => x.sameName);
      this.sameName = sameName[0];

      if (this.sameName == "Yes") {
        this.question.institution = this.question.category;
        this.question.institution_id = this.allinsti.find(
          x => x.name == this.question.category
        )?.id;
        let subbb = this.allinsti
          .filter(
            x =>
              x.name == this.question.category &&
              x.organization_trackid == this.orgId
          )
          .map(x => x.subjects_offered);
        this.subjectsarray = JSON.parse(subbb);
      }
    },

    setloader() {
      this.uploading = true;
    },

    copylink() {
      var cop = document.getElementById("copier");
      cop.select();
      cop.setSelectionRange(0, 99999);
      document.execCommand("copy");
    },
    copynow() {
      document.execCommand("copy");
    },
    stopproceed() {
      this.adding = false;
    },
    ...mapActions("admin", [
      "addQuestion",
      "chekquestion",
      "setFile",
      "setQuestionFileObj",
      "setImageDirectory",
      "fetchQuestion2",
      "updateQuestion",
      "setCurrentModule"
    ])
  },
  computed: {
    ...mapState({
      details: state => state.loginmaster.details,
      loggedin: state => state.loginmaster.loggedIn,
      likequestions: state => state.admin.likequestions,
      uploaded: state => state.exam.uploaded,
      allinsti: state => state.admin.allinstitutions.data,
      retrievedquestion: state => state.admin.editquestion[0],
      fileimage: state => state.admin.qimageurl,
      Categories: state => state.admin.Categories,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.api_origin
    }),
    leav() {
      return this.leaving;
    },
    empties() {
      if (this.question.structure == "MCQ") {
        if (
          this.question.optionA.length == 0 ||
          this.question.optionB.length == 0 ||
          this.question.optionC.length == 0 ||
          this.question.optionD.length == 0
        ) {
          return true;
        } else {
          return false;
        }
      } else if (this.question.structure == "OEQ") {
        if (this.question.oeqanswer.length == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    chkentries() {
      if (this.structure == "Section") {
        return this.question.category == null ||
          this.question.institution == null ||
          this.question.level == null ||
          this.question.course == null ||
          this.question.section == null
          ? true
          : false;
      } else if (this.structure == "Subject") {
        return this.question.category == null ||
          this.question.institution == null ||
          this.question.subject == null
          ? true
          : false;
      } else if (this.structure == "Untabbed") {
        return this.question.category == null ||
          this.question.institution == null
          ? true
          : false;
      } else {
        return true;
      }
    },
    yearArray(){
      const currentYear = new Date();
      const yearArray = []

      for(let i= 1990; i <= currentYear.getFullYear(); i++){
        yearArray.push(i)
      }

      return yearArray;
    }
  }
};
</script>

<style scoped>
.base-select {
  padding: 10px;
}

.btn-sub {
  font-size: 18px;
  font-weight: bold;
  color: white;
  cursor: pointer;
}

.edicon {
  height: 150px;
}

.copyinline {
  background-color: #000000;
  color: white;
  display: inline-flex;
  overflow-x: scroll;
  scrollbar-width: auto;
}

.copyicon {
  width: 20%;
  cursor: pointer;
}

.copytext {
  width: 80%;
  overflow-y: scroll;
}

.copier {
  position: absolute;
  left: -9999px;
}
.active-method {
  background-color: rgb(8, 8, 238);
}

.inactive-method {
  background-color: rgba(128, 128, 136, 0.74);
}
.txtformat {
  font-size: 14px;
  line-height: 10px;
  white-space: nowrap;
}
.txtcode {
  overflow: auto;
}
.sqheader {
  font-size: 1.2rem;
  background-color: rgb(240, 231, 231);
  border-radius: 10px 10px;
  display: flex;
  font-weight: bold;
}
.heasub {
  width: 70%;
}

.sqicon {
  width: 30%;
  text-align: right;
  cursor: pointer;
}

.tooltip {
  width: 700px;
}

.tooltip-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
}

.level-wrapper {
  padding: 13px 20px;
  background: rgb(246, 244, 244);
  border: 1px solid black;
  border-radius: 10px 10px;
}

.head-wrapper {
  display: flex;
  flex: row wrap;
  gap: 10px;
  justify-content: space-between;
  background: rgb(246, 244, 244);
}

.info-span {
  display: block;
  text-align: left;
  color: white;
}

.form-label {
  font-weight: semi-bold;
  font-size: 20px;
}
.leftPreview {
  display: flex;
  justify-content: start;
  gap: 10px;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 200px;
  }
}

@media screen and (min-width: 768px) {
  .image-attachment {
    width: 100%;
    height: 300px;
  }
}
</style>
